module.exports = __webpack_public_path__ + "img/basket.a821c30a.svg";